module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/p7jE6N/tc-custom/9783968654867.jpg?1703129404805",
      "alt": "This image is the cover for the book Heidi, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heidi, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Die beiden Kinderbücher Heidis Lehr- und Wanderjahre und Heidi kann brauchen, was es gelernt hat der Schweizer Autorin Johanna Spyri (1827–1901) aus den Jahren 1880 und 1881 gehören zu den bekanntesten Kinderbüchern der Welt. Mit ihren Heidi-Büchern schuf Johanna Spyri ein noch heute weit verbreitetes romantisches und idealtypisches Bild der Schweiz.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Johanna Spyri\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Johanna Spyri, gebürtig Johanna Louise Heusser (* 12. Juni 1827 in Hirzel, Kanton Zürich; † 7. Juli 1901 in Zürich) war eine Schweizer Kinder- und Jugendschriftstellerin. Sie ist die Schöpferin der bekannten Romanfigur Heidi.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0